<template>
  <agile :options="agileOptions" class="downloadListMobile">
    <DownloadItem v-for="item in items" :item="item" :key="item.title" />
    <template slot="prevButton"
      ><img src="@/assets/svg/slider_left.svg"
    /></template>
    <template slot="nextButton"
      ><img src="@/assets/svg/slider_right.svg"
    /></template>
  </agile>
</template>

<script>
import DownloadItem from "./DownloadItem";

export default {
  name: "DownloadItemListMobile",
  components: {
    DownloadItem,
  },
  props: {
    items: Array,
  },
  computed: {
    agileOptions() {
      return {
        navButtons: false,
        dots: true,
        responsive: [
          {
            breakpoint: 570,
            settings: {
              navButtons: this.$props.items.length > 1,
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/";

.downloadListMobile {
  @include flex-h(space-between, center);
  @include padding-h(10%);

  width: 100%;
  height: 90%;
  margin-top: 10vw;
  color: white;
}
</style>
